export const CHANGE_DURATION_LIST_ID = 'change-duration-list-items';

export enum SelectorType {
  VIDEO = 'Video',
  AUDIO = 'Audio',
  SLIDESHOW = 'Slideshow',
  CUSTOM = 'Custom',
}
